import axios from 'axios'
import {AXIOS_CONFIG} from "./config";

const instance = axios.create(AXIOS_CONFIG)
instance.defaults.withCredentials = true

const request = (type, method, config) => new Promise((resolve, reject) => {
    instance[type](method, config).then(response => {

        !(response.data instanceof Object) && resolve(response.data)
        response.data.success && resolve(response.data.data)

        response.data.data.status === 400 && reject(response.data.data.errors)
        reject(response.data.data)

    }).catch((error) => {
        reject(new Error('Ошибка подключения к серверу\n' + error))
    })
})

export default {
    instance,
    request,
    setToken: token => { instance.defaults.headers.common['X-Api-Key'] = token },
    setSmsToken: token => {
        instance.defaults.headers['X-Sms-Token'] = instance.defaults.headers.common['X-Sms-Token'] = token
        document.cookie = 'sms-token=' + token + '; path=/;'
    },
    get: (method, params) => request('get', method, { params }),
    post: (method, config) => request('post', method, config, false),
    delete: (method, config) => request('delete', method, config, false),
}
